import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { faCircle } from "@fortawesome/free-regular-svg-icons"
import { faDotCircle } from "@fortawesome/free-solid-svg-icons"

import { InlineText } from "../Typography/Typography"
import Icon from "../layout/icon"
import { renderIf } from "../FeatureToggle/FeatureToggle"

import {
  checked as checkedStyles,
  container,
  hidden,
  labelText,
  unchecked,
} from "./styles.module.scss"

let id = 0
const getNextId = () => {
  id += 1
  return id
}
const toSnakeCase = (string) => string.replace(" ", "-")
const getIdFor = (...args) =>
  `${args.reduce(
    (string, arg) => `${string}-${toSnakeCase(arg)}`,
  )}-${getNextId()}`

const Radio = ({ name, value, label, checked, onChange }) => {
  const [focused, setFocused] = useState(false)
  const radioId = getIdFor(name, value)
  const RenderIfChecked = renderIf(checked)
  const RenderIfNotChecked = renderIf(!checked)
  const handleChange = ({ target }) => onChange(target.value)

  return (
    <span className={classNames(container)}>
      <input
        className={classNames(hidden)}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        id={radioId}
        onChange={handleChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <label htmlFor={radioId}>
        <>
          <RenderIfChecked>
            <Icon icon={faDotCircle} className={classNames(checkedStyles)} />
          </RenderIfChecked>
          <RenderIfNotChecked>
            <Icon icon={faCircle} className={classNames(unchecked)} />
          </RenderIfNotChecked>
          <InlineText brand={focused} className={classNames(labelText)}>
            {label}
          </InlineText>
        </>
      </label>
    </span>
  )
}
Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
}

Radio.defaultProps = {
  checked: false,
}

export default Radio
